// extracted by mini-css-extract-plugin
export default {"genericCard":"Lp-z","inline":"Mp-z","mastercard":"Np-z","discover":"Op-z","visa":"Pp-z","amex":"Qp-z","active":"Rp-z"};